import script from "./ProductNutritionInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductNutritionInfo.vue?vue&type=script&setup=true&lang=js"

import "./ProductNutritionInfo.vue?vue&type=style&index=0&id=7208edb4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7208edb4"]])

export default __exports__